window.config = {
  servers: {
    default: 'https://employer.gnis.org.cn'
    // default: 'https://zhaopinhr-uat.feser.com.cn'
  },
  tenementId: 'a9e96f845a7e4ac7a20c19ab0a989dbd'
}



// WEBPACK FOOTER //
// ./src/conf/config.js